import React from "react";
import { IconProps } from "../icon";
import { createIcon } from "../util/create-icon";
// import "../style/css";

const FullscreenExit2Icon: React.ForwardRefExoticComponent<
  IconProps & React.RefAttributes<SVGSVGElement>
> = /*#__PURE__*/ createIcon(
  "fullscreen-exit-2",
  "FullscreenExit2Icon",
  ["currentColor"],
  (colorList) => <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><g fill="none"><path d="M5.00016 1.99998V1.33331H6.3335V1.99998V5.66665V6.33331H5.66683H2.00016H1.3335V4.99998H2.00016H5.00016V1.99998ZM11.0002 1.99998V1.33331H9.66683V1.99998V5.66665V6.33331H10.3335H14.0002H14.6668V4.99998H14.0002H11.0002V1.99998ZM5.00016 14.6666V14V11H2.00016H1.3335V9.66665H2.00016H5.66683H6.3335V10.3333V14V14.6666H5.00016ZM11.0002 14V14.6666H9.66683V14V10.3333V9.66665H10.3335H14.0002H14.6668V11H14.0002H11.0002V14Z" fill={colorList[0]} fillRule="evenodd" clipRule="evenodd"/></g></svg>
);

export default FullscreenExit2Icon;
